function isHomePage(pathname: string) {
  return (pathname === "/");
}

export default isHomePage;
